export default __webpack_public_path__ + "static/media/2.fc9b8471.png";